import React from "react";
import ReportSidebar from "./ReportSidebar/ReportSidebar";
import AddNoteIcon from "../shared-components/icons/AddNoteIcon";

import { ReportSummaryItemApi } from "../api/Reports";
import { SummaryFilterTypeEnum } from "./ReportSidebar/SidebarSummary";
import { FlagCountResponse, GroupCount, TopicCount } from "../api/Items";
import { BlueprintEx2 } from "../api/Blueprints";
import { ReportDetailTypes } from "./utils";

type Props = {
  reportSummary: ReportSummaryItemApi;
  summaryOnly: boolean | undefined;
  isReadOnly: boolean;
  reviewIsInProgress: () => boolean;
  applyFilterByType: (
    type: SummaryFilterTypeEnum,
    event: React.ChangeEvent<HTMLInputElement> | null,
    source: string
  ) => void;
  flagCount: FlagCountResponse | undefined;
  keywordCount: GroupCount | undefined;
  topicCount?: TopicCount;
  keywordFilter: string[];
  topicFilter: string[];
  subStep: string;
  isFilterEmpty: boolean;
  dateFilter: { fromDate: string; toDate: string };
  blueprint: BlueprintEx2 | undefined;
  errorBlueprint: boolean | undefined;
  currentType: ReportDetailTypes;
  modalUnlock: React.ReactNode;
  canAddNotes: boolean;
  companyNote?: string;
  REPORT_DETAILS: { [key in ReportDetailTypes]: JSX.Element };
};

const ReportDetail360 = ({
  reportSummary,
  summaryOnly,
  isReadOnly,
  reviewIsInProgress,
  applyFilterByType,
  flagCount,
  keywordCount,
  topicCount,
  keywordFilter,
  topicFilter,
  subStep,
  isFilterEmpty,
  dateFilter,
  blueprint,
  errorBlueprint,
  currentType,
  modalUnlock,
  canAddNotes,
  companyNote,
  REPORT_DETAILS,
}: Props) => {
  return (
    <div className="flex flex-col">
      <div className="flex">
        <div
          className={
            summaryOnly
              ? "w-full"
              : "bg-white p-6 rounded-xl shadow shadow-gray-300 print:p-0 print:shadow-none w-full"
          }
        >
          {reviewIsInProgress() && canAddNotes && companyNote && (
            <div className="bg-yellow-100 flex flex-start  text-gray-700 rounded-md text-sm leading-5 font-medium mb-4 p-4 items-center">
              <AddNoteIcon />
              <span className="ml-4">{companyNote}</span>
            </div>
          )}
          <div className="grid grid-cols-8 gap-6">
            <div className="col-span-2 print:hidden">
              <ReportSidebar
                blueprint={blueprint}
                errorBlueprint={!!errorBlueprint}
                report={reportSummary}
                isReadOnly={isReadOnly}
                reportDetailType={currentType}
                applyFilterByType={applyFilterByType}
                flagCount={flagCount}
                keywordCount={keywordCount}
                topicCount={topicCount}
                keywordFilter={keywordFilter}
                topicFilter={topicFilter}
                subStep={subStep}
                isFilterEmpty={isFilterEmpty}
                dateFilter={dateFilter}
                summaryOnly={summaryOnly}
              />
            </div>
            <div className="col-span-6 print:col-span-8">
              {REPORT_DETAILS[currentType]}
            </div>
          </div>
        </div>
      </div>
      {modalUnlock}
    </div>
  );
};

export default ReportDetail360;
